<template>
  <div class="roomInfo">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ roomData.name }}</span>
    </div>
    <p class="part_title">会议信息</p>
    <van-cell-group>
      <van-field v-model="dataForm.theme" class="actValue" required label="会议主题" placeholder="请输入会议主题" @input="changeDataForm" />
      <van-cell required title="开始时间">
        <span class="value" @click="showPicker =true">{{ dataForm.startTime }}</span>
      </van-cell>
      <van-cell required title="结束时间">
        <span class="value" @click="showPicker1 =true">{{ dataForm.endTime }}</span>
      </van-cell>
      <van-cell required title="会议类型" @click="showMeetingType = true">
        <template #right-icon>
          <span style="display: flex; align-items: center">
            {{ dataForm.meetingTypeText }}
            <van-icon name="arrow" class="search-icon" />
          </span>
        </template>
      </van-cell>
      <van-cell required title="联系人" @click="addHost">
        <template #right-icon>
          <span style="display: flex; align-items: center">
            {{ dataForm.organizer }}
            <van-icon name="arrow" class="search-icon" />
          </span>
        </template>
      </van-cell>
      <van-cell-group v-if="dataForm.meetingType === 'PRIVATE'">
        <van-cell title="内部参会人" @click="addStaff">
          <template #right-icon>
            <span style="display: flex; align-items: center">
              {{ dataForm.inners.length }}人
              <van-icon name="arrow" class="search-icon" />
            </span>
          </template>
        </van-cell>
        <van-cell title="外部参会人" @click="addOthers">
          <template #right-icon>
            <span style="display: flex; align-items: center">
              {{ dataForm.outers.length }}人
              <van-icon name="arrow" class="search-icon" />
            </span>
          </template>
        </van-cell>
        <van-cell title="会务要求" @click="addMaterials">
          <template #right-icon>
            <span style="display: flex; align-items: center">
              {{ dataForm.requires.length }}项
              <van-icon name="arrow" class="search-icon" />
            </span>
          </template>
        </van-cell>
      </van-cell-group>
      <van-cell-group v-else>
        <van-field v-model.trim="dataForm.outsizeAttendeeCount" class="actValue" required type="number" label="人数上限" placeholder="请输入参会人数" @input="changeDataForm" />
        <van-field v-model.trim="dataForm.coOrganization" class="actValue" label="协办方" placeholder="请输入协办方" @input="changeDataForm" />
        <van-cell title="会务要求" @click="addMaterials">
          <template #right-icon>
            <span style="display: flex; align-items: center">
              {{ dataForm.requires.length }}项
              <van-icon name="arrow" class="search-icon" />
            </span>
          </template>
        </van-cell>
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="dataForm.meetingContent" type="textarea" label="会议内容" autosize placeholder="请输入会议内容" @input="changeDataForm" />
        <van-cell title="会议议程">
          <template #right-icon>
            <van-icon name="plus" class="search-icon" @click="addAgenda" />
          </template>
        </van-cell>
        <van-field
          v-for="(item, index) in dataForm.agendasList"
          :key="index"
          v-model="item.value"
          required
          :label="`议程${index + 1}`"
          placeholder="请输时间及内容"
          @input="changeDataForm"
        >
          <template #right-icon>
            <van-icon name="close" class="search-icon" @click="() => closeAgenda(index)" />
          </template>
        </van-field>
        <van-cell title="会议资料">
          <template #right-icon>
            <van-uploader accept="MIME_type" :after-read="afterRead">
              <van-icon name="plus" class="search-icon" />
            </van-uploader>
          </template>
        </van-cell>
        <van-cell v-for="(item, index) in dataForm.materials" :key="index" :title="item.materialName">
          <template #right-icon>
            <van-icon name="close" class="search-icon" @click="() => delMaterial(index)" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-cell-group>
    <p class="part_title">会议规则</p>
    <van-cell-group>
      <van-cell required title="签到规则" is-link :value="dataForm.ruleText" @click="showRule = true" />
      <van-field v-model="dataForm.signTime" type="number" class="actValue" required label="会议前x分钟开始签到" @input="changeDataForm" />
    </van-cell-group>
    <p v-if="dataForm.meetingType === 'PUBLIC'" class="part_title">会议邀请函</p>
    <van-cell-group v-if="dataForm.meetingType === 'PUBLIC'">
      <van-cell title="邀请函样式">
        <template #right-icon>
          <span style="display: flex; align-items: center; color: #409EFF" @click="onShowImg">
            预览
          </span>
        </template>
      </van-cell>
      <div style="display: flex">
        <div v-for="item in imgList" :key="item.id" :class="dataForm.pageStyle === item.value ? 'imgSelect' : 'img'" @click="() => selectStyle(item)">
          <img :src="item.url" alt="">
        </div>
      </div>
    </van-cell-group>
    <div class="btn">
      <van-button type="info" size="large" @click="meetingCreate">提交预约申请</van-button>
    </div>
    <van-popup v-model="showRule" position="bottom" :style="{ height: '50%' }">
      <van-picker
        title="签到规则"
        show-toolbar
        value-key="text"
        :default-index="dataForm.ruleIndex"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showRule = false"
      />
    </van-popup>
    <van-popup v-model="showMeetingType" position="bottom" :style="{ height: '50%' }">
      <van-picker
        title="会议类型"
        show-toolbar
        value-key="text"
        :default-index="dataForm.meetingTypeIndex"
        :columns="meetingTypeColumns"
        @confirm="onMeetingTypeConfirm"
        @cancel="showMeetingType = false"
      />
    </van-popup>
    <van-popup v-model="showPicker" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        :filter="filter"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="timeConfirm"
        @cancel="showPicker =false"
      />
    </van-popup>
    <van-popup v-model="showPicker1" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="currentDate1"
        type="datetime"
        :formatter="formatter"
        :min-date="minDate1"
        :max-date="maxDate"
        :filter="filter"
        @confirm="endTimeConfirm"
        @cancel="showPicker1 = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { meetingCreate, getRoomInfo, UploadFile, staffMaps } from '@/api/user';
import moment from 'moment';
import { Notify } from 'vant';
import invitations1 from '../../../assets/img/invitations_1.jpg';
import invitations2 from '../../../assets/img/invitations_2.jpg';
import invitations3 from '../../../assets/img/invitations_3.jpg';

export default {
  name: 'RoomInfo',
  components: {
    [Notify.name]: Notify
  },
  data() {
    return {
      roomData: {},
      roomId: '',
      subHead: '',
      value: '',
      privateRequestValue: [
        'theme',
        // 'inners',
        'organizer',
        'organizerId',
        'signType',
        'signTime',
        'startTime',
        'endTime',
        'meetingRoomId',
        'meetingRoomName'
      ],
      publicRequestValue: [
        'theme',
        'organizer',
        'organizerId',
        'signType',
        'signTime',
        'startTime',
        'endTime',
        'meetingRoomId',
        'outsizeAttendeeCount',
        'meetingRoomName'
      ],
      dataForm: {
        theme: '',
        visitDate: '',
        meetingContent: '',
        coOrganization: '',
        outsizeAttendeeCount: '',
        inners: [],
        outers: [],
        materials: [],
        requires: [],
        // agendasList: [], // 会议议程
        organizer: '',
        organizerId: '',
        signType: 'ANYWAY_SIGN',
        signTime: '',
        meetingType: 'PRIVATE',
        startTime: '',
        endTime: '',
        meetingRoomId: '',
        meetingRoomName: '',
        ruleText: '手动签到/通行会议室门禁',
        ruleIndex: 0,
        meetingTypeText: '固定会议',
        meetingTypeIndex: 0,
        agendas: [],
        pageStyle: 'blue',
        agendasList: [],
      },
      showPicker: false,
      showPicker1: false,
      currentDate: '',
      currentDate1: '',
      minDate1: '',
      minDate: new Date(),
      maxDate: '',
      // inners: [],
      columns: [
        { text: '手动签到/通行会议室门禁', value: 'ANYWAY_SIGN' },
        { text: '仅手动签到', value: 'MANUAL_SIGN' },
        { text: '仅通行会议室门禁', value: 'ACCESS_AUTOMATIC_SIGN' }
      ],
      meetingTypeColumns: [
        { text: '固定会议（有固定参会人员，会议信息由系统自动通知）', value: 'PRIVATE' },
        { text: '开放会议（没有固定参会人员，需自行发送会议邀请函）', value: 'PUBLIC' }
      ],
      showRule: false,
      showMeetingType: false,
      imgList: [
        { url: invitations1, id: 1, value: 'blue' },
        { url: invitations2, id: 2, value: 'lightBlue' },
        { url: invitations3, id: 3, value: 'green' }
      ],
      showUrl: invitations1
    };
  },
  computed: {
    submitForm() {
      this.dataForm = this.$store.state.submitForm;
      return this.$store.state.submitForm;
    }
  },
  watch: {
    submitForm() {}
  },
  created() {
    let roomId = '';
    if (this.$route.query && this.$route.query.id) {
      roomId = this.$route.query.id;
    }
    if (roomId) {
      getRoomInfo({ id: roomId }).then(res => {
        this.$store.dispatch('setRoomData', { data: res.data });
        this.roomData = this.$store.state.roomData;
        this.setTime();
      });
      // TODO 获取默认的联系人 第一次进来才有
      this.getMySelf();
    } else {
      this.roomData = this.$store.state.roomData;
      this.setTime();
    }
  },
  methods: {
    getMySelf() {
      staffMaps({}).then(res => {
        if (res.data && res.data.nodes) {
          let personalInfo = {};
          function deepData(arr) {
            arr.forEach(item => {
              if (item.currentUser) {
                personalInfo = item;
              } else if (item.nodes) {
                deepData(item.nodes);
              }
            });
          }
          deepData(res.data.nodes);
          const data = {};
          data.organizerId = personalInfo.id;
          data.organizer = personalInfo.name;
          data.company = personalInfo.company;
          data.companyId = personalInfo.companyId;
          this.$store.dispatch('setOrganizer', { data: data });
        }
      });
    },
    meetingCreate() {
      this.dataForm.meetingRoomId = this.roomData.id;
      this.dataForm.meetingRoomName = this.roomData.name;
      const keys = Object.keys(this.dataForm);
      let pass = true;
      const requestValue = this.dataForm.meetingType === 'PUBLIC' ? this.publicRequestValue : this.privateRequestValue;
      keys.forEach(item => {
        if (requestValue.includes(item)) {
          if (!this.dataForm[item] || this.dataForm[item] === undefined || this.dataForm[item].length === 0) {
            Notify({ type: 'warning', message: '请填写完整' });
            pass = false;
            return;
          }
        }
      });
      if (pass) {
        this.dataForm.agendas = [];
        this.dataForm.agendasList.forEach((item) => {
          if (item.value) {
            this.dataForm.agendas.push(item.value);
          }
        });
        // this.$toast.loading({
        //   message: '提交中...',
        //   forbidClick: true,
        //   loadingType: 'spinner',
        //   duration: 0
        // });
        meetingCreate(this.dataForm).then(res => {
          if (res.code === 200) {
            this.$toast.clear();
            this.$router.push({ name: 'bookSuccess' });
            this.$store.dispatch('clearSubmitForm');
            this.$store.dispatch('setDate', { data: moment().format('YYYY-MM-DD') });
          } else {
            this.$toast.clear();
          }
        });
      }
    },
    goBack() {
      this.$router.push({ name: 'meetingBook' });
      this.$store.dispatch('clearSubmitForm');
    },
    filter(type, options) {
      if (type === 'minute') {
        return options.filter(option => option % 10 === 0);
      } else {
        return options;
      }
    },
    formatter(type, value) {
      switch (type) {
        case 'year':
          value = `${value}年`;
          break;
        case 'month':
          value = `${value}月`;
          break;
        case 'day':
          value = `${value}日`;
          break;
        case 'hour':
          value = `${value}时`;
          break;
        case 'minute':
          value = `${value}分`;
          break;
      }
      return value;
    },
    // 设置默认时间为当前时间的下一个整点
    setTime() {
      const now = moment().format('HH:mm:ss');
      var num = now.indexOf(':');
      var time = Number(now.substring(0, num)) + 1;
      if (time.toString().length === 1) {
        time = '0' + time;
      }
      const { openTime, closedTime } = this.roomData;
      const start = openTime.split(':');
      const end = closedTime.split(':');
      let minHour = '';
      let maxHour = '';
      if (start[0].startsWith('0')) {
        minHour = start[0].charAt(1);
      } else {
        minHour = start[0];
      }
      if (end[0].startsWith('0')) {
        maxHour = end[0].charAt(1);
      } else {
        maxHour = end[0];
      }
      const startTime = this.$store.state.submitForm.startTime;
      const endTime = this.$store.state.submitForm.endTime;
      this.dataForm.startTime = startTime || moment(this.$store.state.meetingDate).format('YYYY-MM-DD ') + time + ':00';
      this.dataForm.endTime = endTime || moment(this.$store.state.meetingDate).format('YYYY-MM-DD ') + time + ':00';
      this.currentDate = startTime ? new Date(moment(startTime).format('YYYY/MM/DD HH:mm')) : new Date(moment(this.$store.state.meetingDate).format('YYYY/MM/DD ') + time + ':00'); // ios不支持YYYY_MM_DD 的new Date写法
      this.currentDate1 = endTime ? new Date(moment(endTime).format('YYYY/MM/DD HH:mm')) : new Date(moment(this.$store.state.meetingDate).format('YYYY/MM/DD ') + time + ':00'); // ios不支持YYYY_MM_DD 的new Date写法
      this.minDate = new Date(moment().format(`YYYY/MM/DD ${minHour}`) + ':00');
      this.minDate1 = new Date(moment().format(`YYYY/MM/DD ${minHour}`) + ':00');
      const prDate = new Date();
      const presentYear = prDate.getFullYear() + 1;
      const presentMonth = prDate.getMonth() + 1;
      const presentDate = prDate.getDate();
      this.maxDate = new Date(moment().format(`${presentYear}/${presentMonth}/${presentDate} ${maxHour * 1}`) + ':00');
      this.changeDataForm();
    },
    timeConfirm(val) {
      const d = new Date().getTime();
      const d1 = new Date(val).getTime();
      if (d1 < d) {
        this.$toast({
          message: '开始时间不能在当前时间之前'
        });
        return;
      }
      this.dataForm.startTime = moment(val).format('YYYY-MM-DD HH:mm');
      this.showPicker = false;
      this.changeDataForm();
    },
    endTimeConfirm(val) {
      const d = new Date().getTime();
      const d1 = new Date(val).getTime();
      if (d1 < d) {
        this.$toast({
          message: '结束时间不能在当前时间之前'
        });
        return;
      }
      this.dataForm.endTime = moment(val).format('YYYY-MM-DD HH:mm');
      this.showPicker1 = false;
      this.changeDataForm();
    },
    addHost() {
      this.$router.push({ name: 'addHost' });
    },
    addStaff() {
      this.$router.push({ name: 'addStaff' });
    },
    addOthers() {
      this.$router.push({ name: 'addOthers' });
    },
    addMaterials() {
      this.$router.push({ name: 'addMaterials' });
    },
    onConfirm(value, index) {
      this.showRule = false;
      this.dataForm.signType = value.value;
      this.dataForm.ruleText = value.text;
      this.dataForm.ruleIndex = index;
      this.changeDataForm();
    },
    onMeetingTypeConfirm(value, index) {
      this.showMeetingType = false;
      this.dataForm.meetingType = value.value;
      const str = value.text.split('（');
      this.dataForm.meetingTypeText = str[0];
      this.dataForm.meetingTypeIndex = index;
      this.changeDataForm();
    },
    changeDataForm() {
      this.$store.dispatch('setSubmitForm', { data: this.dataForm });
    },
    // addAgenda 添加会议议程
    addAgenda() {
      const data = { value: '' };
      this.dataForm.agendasList.push(data);
    },
    // closeAgenda 关闭会议议程
    closeAgenda(index) {
      this.dataForm.agendasList = this.dataForm.agendasList.filter((item, idx) => {
        return index !== idx;
      });
    },
    afterRead(e) { // 上传的会议资料
      const data = { materialName: e.file.name };
      const fromData = new FormData();
      fromData.append('file', e.file);
      // this.$toast.loading({
      //   message: '上传中...',
      //   forbidClick: true,
      //   loadingType: 'spinner',
      //   duration: 0
      // });
      UploadFile(fromData).then(res => {
        data.materialUrl = res.data;
        this.dataForm.materials.push(data);
        this.$toast.clear();
        this.changeDataForm();
      }).catch(err => {
        setTimeout(() => { this.$toast.clear(); }, 3000);
      });
    },
    delMaterial(idx) {
      this.dataForm.materials = this.dataForm.materials.filter((item, index) => {
        return index !== idx;
      });
      this.changeDataForm();
    },
    selectStyle(e) {
      this.dataForm.pageStyle = e.value;
      this.showUrl = e.url;
      this.changeDataForm();
    },
    onShowImg() {
      this.$router.push({ name: 'invitations', query: { view: true, pageStyle: this.dataForm.pageStyle }});
      // ImagePreview([this.showUrl]);
    }
  }
};
</script>

<style lang="less">
.roomInfo {

  padding-bottom: 10px;

  .van-cell {
    display: flex;
    justify-content: space-between;
  }
  .btn {
    margin: 0.2rem;
  }
  .part_title {
    color: #888;
    font-size: 0.14rem;
    margin-left: 0.15rem;
    line-height: 0.45rem;
  }
  .van-field__label {
    color: #333333;
  }
  .value {
    color: #323233;
  }
  .columnItem {
    color: blue;
  }

  .img {
    margin: 0.1rem;
    position: relative;
    img {
      width: 0.7rem;
      cursor: pointer;
    }
  }
  .imgSelect {
    margin: 0.1rem;
    position: relative;
    img {
      width: 0.7rem;
      cursor: pointer;
      border: 3px solid #409EFF;
    }
  }
}

.van-ellipsis {
  font-size: 0.125rem;
}
.van-picker__title {
  font-size: 0.15rem;
}

</style>
